import Vue from 'vue'
import App from './App.vue'
import './assets/css/app.css'
import router from './router'
import axios from 'axios'
// import VueGtm from '@gtm-support/vue2-gtm'
// import VueGtag from 'vue-gtag'
import VueAnalytics from 'vue-analytics'

axios.defaults.baseURL = `https://b2b-api.mncplay.id/frontend/web/index.php/webpurchase/actionplays`
//axios.defaults.baseURL = `http://localhost/api-open-content-prod-addon/frontend/web/index.php/webpurchase/actionplays`
//axios.defaults.baseURL = `http://localhost:8000/index.php/webpurchase/actionplays`
axios.defaults.headers.common = {'Authorization': `Bearer MSzNT2Jk-mILyGIVk9lcjxHUc2HKfi1L-APPPURCHASE`}

// Vue.use(VueGtm, {
//   id: 'UA-111351533-22',
//   enabled: true,
//   vueRouter: router
// })

// Vue.use(VueGtag, {
//   config: { id: 'UA-111351533-22'}
// }, router)

Vue.use(VueAnalytics, {
  id: 'UA-111351533-22',
  router
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
